import { render, staticRenderFns } from "./ItemChecklist.vue?vue&type=template&id=8bba8ed6"
import script from "./ItemChecklist.vue?vue&type=script&lang=js"
export * from "./ItemChecklist.vue?vue&type=script&lang=js"
import style0 from "./ItemChecklist.vue?vue&type=style&index=0&id=8bba8ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports